export const cssCurrent = "dr-current";
export const cssHidden = "dr-hidden";
export const delimiter = "/";
export const empty = "";
export const hash = "#";
export const notHash = /.*#/;
export const render = window.requestAnimationFrame;
export const selectorHasHash = "a[href^='#']";
